import type { UserOngoingPath } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

/* istanbul ignore next */
const { useGet: useUserOngoingPath } = getCRUDHooks<UserOngoingPath>({
  entityName: 'userOngoingPath',
  get: ({ userId }) => clientApi.getOCClient().helpers.user.users.getUserOngoingPath(userId),
});

export { useUserOngoingPath };
